export default "__VITE_ASSET__DSrEkozZ__"